import React from 'react';
import {useNavigate} from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const RecentPostItem = ({post}) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'published':
        return 'text-success bg-success/10';
      case 'draft':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return 'unknown';
    }
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleEdit = () => {
    navigate(`/admin-post-editor?id=${post?.id}`);
  };

  const handleView = () => {
    navigate(`/blog-post-detail?slug=${post?.slug}`);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 transition-all duration-250 hover:shadow-subtle">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="w-full lg:w-32 h-32 lg:h-20 rounded-lg overflow-hidden flex-shrink-0">
          <Image
            src={post?.heroImage}
            alt={post?.heroImageAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-2">
            <h4 className="text-base font-semibold text-foreground line-clamp-1">{post?.title}</h4>
            <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(post?.status)}`}>
              {post?.status?.charAt(0)?.toUpperCase() + post?.status?.slice(1)}
            </span>
          </div>

          <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{post?.excerpt}</p>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <Icon name="User" size={14} color="var(--color-primary)"/>
                <span>{post?.author}</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Calendar" size={14} color="var(--color-primary)"/>
                <span>{formatDate(post?.updatedAt)}</span>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={handleEdit}
                iconName="Edit"
                iconPosition="left"
              >
                Edit
              </Button>
              {post?.status === 'published' && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={handleView}
                  iconName="ExternalLink"
                  iconPosition="left"
                >
                  View
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentPostItem;